import { useMemo } from "react"

import type { DashboardUseCase } from "../../../types/use-case.types"

import { SiteCards } from "./site-cards"
import { SiteCharts } from "./site-charts"
import { SiteSummaryTable } from "./site-summary-table"

type SiteComparisonTabProps = {
  useCases: DashboardUseCase[]
}

export function SiteComparisonTab({ useCases }: SiteComparisonTabProps) {
  const siteMap = useMemo(() => {
    const map = new Map<string, DashboardUseCase[]>()
    for (const uc of useCases) {
      for (const site of uc.sites) {
        if (!map.has(site)) map.set(site, [])
        map.get(site)!.push(uc)
      }
    }
    return map
  }, [useCases])

  return (
    <div className="space-y-6">
      <SiteSummaryTable allUseCases={useCases} siteMap={siteMap} />
      <SiteCharts siteMap={siteMap} />
      <SiteCards siteMap={siteMap} />
    </div>
  )
}
